export const adminWallets = [
    "0xBFf06DEb7059B475a734E71D101b2D9fF3247cFF",
    "0x1c968555856C27382e2432E045D9332929dBf6C8"
].map((address) => address.toLowerCase());

export const isAdminWallet = (walletAddress) => {
    return walletAddress && adminWallets.includes(walletAddress.toLowerCase());
};